// var TweenMax = require("./TweenMax.min.js");
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

// import ScrollMagic from "scrollmagic";
// var addIndicators = require("../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators");
// var animation = require("../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap");

gsap.registerPlugin(ScrollTrigger);
//SCROLL PARALLAX
gsap.utils.toArray('.scrollSpeed').forEach((elem, i) => {
  var trigger = (elem.getAttribute('data-trigger'));
  var trigger = ('#'+trigger);
  const from = JSON.parse(elem.dataset.from);
  const to = JSON.parse(elem.dataset.to);
  const stObj = {
    scrollTrigger: {
       trigger: trigger,
       start: "top 60%",
       end:"bottom",
       scrub:true,
      //  markers:true
    }
  };
  const vars = Object.assign(to, stObj);
  gsap.fromTo(elem, from, vars);
});

//REVEAL ANIMATION
gsap.utils.toArray(".reveal-up").forEach(function (elem) {
  ScrollTrigger.create({
    trigger: elem,
    start: "top 90%",
    // end: "bottom 20%",
    //markers: true,
    onEnter: function () {
      gsap.fromTo(
        elem,
        { y: 100, autoAlpha: 0 },
        {
          duration: 1.25,
          y: 0,
          autoAlpha: 1,
          ease: "back",
          overwrite: "auto"
        }
      );
    },
    onLeave: function () {
      gsap.fromTo(elem, { autoAlpha: 1 }, { autoAlpha: 0, overwrite: "auto" });
    },
    onEnterBack: function () {
      gsap.fromTo(
        elem,
        { y: -100, autoAlpha: 0 },
        {
          duration: 1.25,
          y: 0,
          autoAlpha: 1,
          ease: "back",
          overwrite: "auto"
        }
      );
    },
    onLeaveBack: function () {
      gsap.fromTo(elem, { autoAlpha: 1 }, { autoAlpha: 0, overwrite: "auto" });
    }
  });
});

const showAnim = gsap.from('#logoholder', { 
  yPercent: 0,
  paused: true,
  duration: 0.2,
}).progress(1);

ScrollTrigger.create({
  trigger: "#topLogoTrigger",
  start: "top 59%",
  end: 99999,
  onUpdate: (self) => {
    self.direction === -1 ? showAnim.play() : showAnim.reverse()
  }
});

/*
logoholder
//NAV SCROLL
const showAnim = gsap.from('#logo-text', {
  xPercent: -100,
  width: 0,
  paused: true,
  duration: 0.2
}).progress(1);
ScrollTrigger.create({
  trigger: "#topLogoTrigger",
  start: "top 60%",
  end:"bottom",
  //markers:true,
  onUpdate: (self) => {
    self.direction === -1 ? showAnim.play() : showAnim.reverse()
  }
});

const iconAnim = gsap.from('#logo-icon', {
  xPercent: 0,
  width: 50,
  paused: true,
  margin: 0,
  duration: 0.2
}).progress(1);

ScrollTrigger.create({
  trigger: "#topLogoTrigger",
  start: "top 60%",
  end:"bottom",
  onUpdate: (self) => {
    self.direction === -1 ? iconAnim.play() : iconAnim.reverse()
  }
});

const wrapperIconAnim = gsap.from('.logo-icon-wrapper', {
  padding: "14 16",
  background: "#73A1C2",
  width: 80,
  height: 80,
  boxShadow: "rgb(20 20 64 / 44%) 2px 4px 19px -6px",
  paused: true,
  duration: 0.2
}).progress(1);

ScrollTrigger.create({
  trigger: "#topLogoTrigger",
  start: "top 60%",
  width: 150,
  height: 150,
  end:"bottom",
  onUpdate: (self) => {
    self.direction === -1 ? wrapperIconAnim.play() : wrapperIconAnim.reverse()
  }
});

const socialAnim = gsap.from('#socialNav', {
  xPercent: 0,
  top: -100,
  paused: true,
  xPercent: -8,
  duration: 0.2
}).progress(1);

ScrollTrigger.create({
  trigger: "#topLogoTrigger",
  start: "top 60%",
  end:"bottom",
  onUpdate: (self) => {
    self.direction === -1 ? socialAnim.play() : socialAnim.reverse()
  }
});

/*
const desktopNavAnim = gsap.from('#desktopNav', {
  xPercent: 0,
  top: -10,
  paused: true,
  xPercent: -2,
  duration: 0.2,
  boxShadow: "rgb(81 78 112 / 15%) 0px 0.5rem 1rem"
}).progress(1);

ScrollTrigger.create({
  trigger: "#topLogoTrigger",
  start: "top 60%",
  end:"bottom",
  onUpdate: (self) => {
    self.direction === -1 ? desktopNavAnim.play() : desktopNavAnim.reverse()
  }
});
*/
/*
const mobileAnim = gsap.from('#mobileNav', {
  //yPercent: -0,
  duration: 0.5
}).progress(1);

ScrollTrigger.create({
  trigger: "#topLogoTrigger",
  start: "top 60%",
  end:"bottom",
  onUpdate: (self) => {
    self.direction === -1 ? mobileAnim.play() : mobileAnim.reverse()
  }
});

const mobileButton = gsap.from('.menu-button-wrapper', {
  boxShadow: "2px 4px 19px -6px rgb(126, 126, 148)",
  background: "#ffffff",
  xPercent: -20,
  duration: 0.3
}).progress(1);
ScrollTrigger.create({
  trigger: "#topLogoTrigger",
  start: "top 60%",
  end:"bottom",
  onUpdate: (self) => {
    self.direction === -1 ? mobileButton.play() : mobileButton.reverse()
  }
});


//Layer Panel
gsap.to(".panel:not(:last-child)", {
  yPercent: -100, 
  ease: "none",
  stagger: 0.5,
  scrollTrigger: {
    trigger: "#container",
    start: "top top",
    end: "+=300%",
    scrub: true,
    pin: true
  }
});
*/

//gsap.set(".panel", {zIndex: (i, target, targets) => targets.length - i});